import React from 'react';
import { useAiExtensionConnectionStatus } from '../../services/ai-adapter/connection-check';

const CHROME_STORE_URL =
    'https://chromewebstore.google.com/detail/lchnddabhibpklikkfpjehfgccjddohg?utm_source=item-share-cb';

const UNAVAILABLE_TOOLTIP =
    'You need to install and turn on your Ctrl Enter extension to use this feature';

export function useTalkToAiTrigger(onOpen: () => void) {
    const [showExtensionInstructions, setShowExtensionInstructions] = React.useState(false);
    const { checking, connected } = useAiExtensionConnectionStatus();
    const isUnavailable = !checking && connected === false;
    const isChecking = checking || connected === null;

    const openExtensionStore = React.useCallback(() => {
        window.open(CHROME_STORE_URL, '_blank', 'noopener,noreferrer');
    }, []);

    const handleClick = () => {
        if (isUnavailable) {
            setShowExtensionInstructions(true);
            return;
        }
        if (connected === true) {
            onOpen();
        }
    };

    const handleRetryConnection = React.useCallback(() => {
        window.location.reload();
    }, []);

    const tooltipTitle = isUnavailable ? UNAVAILABLE_TOOLTIP : 'Ask AI';

    return {
        handleClick,
        checking: isChecking,
        tooltipTitle,
        showExtensionInstructions,
        closeExtensionInstructions: () => setShowExtensionInstructions(false),
        openExtensionStore,
        retryConnection: handleRetryConnection,
    };
}
